export const COLORWAYS = [
  {
    id: "CRIMSON",
    filter: "BLACK",
    swatch: "#141414",
    accent: "#E21C2A",
    desc: "Black body / white side lines / deep-crimson micro-check waistband",
    img: "/images/crimson-flat.jpg",
    onbody: "/images/crimson-studio.jpg",
    detail: "/images/crimson-waistband.jpg",
  },
  {
    id: "CONCRETE",
    filter: "GREY",
    swatch: "#9B9B98",
    accent: "#8A8A8A",
    desc: "Heather-grey body / charcoal side lines / black-and-grey waistband",
    img: "/images/concrete-flat.jpg",
    onbody: "/images/concrete-studio.jpg",
    detail: "/images/concrete-waistband.jpg",
  },
  {
    id: "FOREST",
    filter: "GREEN",
    swatch: "#14211A",
    accent: "#2E5C43",
    desc: "Dark forest-green body / warm-cream side lines / black-and-green waistband",
    img: "/images/forest-flat.jpg",
    onbody: "/images/forest-studio.jpg",
    detail: "/images/forest-waistband.jpg",
  },
  {
    id: "BONE",
    filter: "CREAM",
    swatch: "#E6DECB",
    accent: "#8C5638",
    desc: "Warm cream body / espresso-brown side lines / burgundy-and-brown waistband",
    img: "/images/bone-flat.jpg",
    onbody: "/images/bone-studio.jpg",
    detail: "/images/bone-waistband.jpg",
  },
  {
    id: "MIDNIGHT",
    filter: "NAVY",
    swatch: "#0F1626",
    accent: "#5E7CA0",
    desc: "Dark navy body / silver-grey side lines / navy-and-ice waistband",
    img: "/images/midnight-flat.jpg",
    onbody: "/images/midnight-studio.jpg",
    detail: "/images/midnight-waistband.jpg",
  },
];

export const SIZES = ["XS", "S", "M", "L", "XL", "XXL"];

export const skuFor = (colorway, size) => `LL-HBSP-${colorway}-${size}`;

export const colorwayById = (id) => COLORWAYS.find((c) => c.id === id) || COLORWAYS[0];

export const money = (n) => `$${Number(n).toFixed(2)}`;

export const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric", timeZone: "UTC" });
  } catch {
    return iso;
  }
};

export const POLICIES = {
  "preorder-policy": {
    title: "PREORDER POLICY",
    body: [
      "DROP 001 is offered as a seven-day preorder. When you place a preorder, you are charged in full at checkout and your item is reserved for production.",
      "When the preorder window closes, final quantities are sent to our manufacturer. Production then begins and typically takes several weeks before shipping.",
      "The estimated shipping window is shown on the product page, in your cart, at checkout and in your confirmation email. These dates are estimates; production and delivery updates are sent by email if timelines change.",
      "Preorders can be cancelled for a full refund any time before the preorder window closes. After the window closes and production begins, orders can no longer be cancelled.",
      "If your order contains a preorder item, the entire order ships together during the estimated window.",
    ],
  },
  "shipping-returns": {
    title: "SHIPPING & RETURNS",
    body: [
      "Shipping is charged separately at checkout and calculated based on your destination.",
      "Preorder items ship during the estimated window shown at checkout. You will receive a shipping confirmation with tracking when your order leaves our facility.",
      "Returns are accepted within 14 days of delivery for unworn, unwashed items with tags attached. To start a return, contact us with your order number.",
      "Refunds are issued to the original payment method once the returned item is received and inspected.",
      "Customers are responsible for return shipping costs unless the item arrived damaged or incorrect.",
    ],
  },
  privacy: {
    title: "PRIVACY POLICY",
    body: [
      "We collect the information needed to process your order: your name, email, shipping address, optional phone number and purchase details. Payment details are processed securely by our payment provider and are never stored on our servers.",
      "If you join the drop list, we store your email and/or phone number together with the consent choices you made and the time consent was given. We only send marketing messages to contacts who explicitly opted in.",
      "We do not sell your personal information. Data is shared only with the service providers required to operate the store (payments, shipping, email delivery).",
      "You can request a copy or deletion of your data at any time by contacting us.",
    ],
  },
  terms: {
    title: "TERMS OF SERVICE",
    body: [
      "By using this website and placing an order you agree to these terms. All products are offered as limited preorders and availability is not guaranteed until an order is confirmed.",
      "Prices are listed in USD. We reserve the right to correct pricing errors and to cancel orders affected by them.",
      "All content on this site, including the ETERNEL name, logo, imagery and designs, is the property of ETERNEL and may not be used without permission.",
      "These terms are governed by the laws of the seller's place of business. Nothing in these terms limits your statutory consumer rights.",
    ],
  },
  "sms-terms": {
    title: "SMS TERMS",
    body: [
      "If you opt in to SMS updates, ETERNEL will send text messages about drop announcements and order updates to the phone number you provided.",
      "Message frequency varies. Message and data rates may apply. Consent to receive SMS is not a condition of purchase.",
      "You can opt out at any time by replying STOP to any message. Reply HELP for help.",
      "Carriers are not liable for delayed or undelivered messages.",
    ],
  },
};
